let csrfPromise = null;
let csrfToken = '';

async function ensureCSRF() {
  if (csrfToken) return csrfToken;
  if (!csrfPromise) {
    csrfPromise = fetch('/api/csrf', { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => {
        csrfToken = data?.token || '';
        return csrfToken;
      })
      .catch(() => '')
      .finally(() => {
        csrfPromise = null;
      });
  }
  return csrfPromise;
}

export async function apiFetch(path, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {})
  };
  if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    const token = await ensureCSRF();
    if (token) headers['X-CSRF-Token'] = token;
  }

  const res = await fetch(path, {
    credentials: 'include',
    headers,
    ...options,
    method
  });

  if (res.status === 204) return null;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const message = data?.error?.message || 'Request failed';
    const err = new Error(message);
    err.status = res.status;
    err.code = data?.error?.code || '';
    throw err;
  }
  return data;
}
